import { render, staticRenderFns } from "./DateRangeDialog.vue?vue&type=template&id=87b015e0&scoped=true"
import script from "./DateRangeDialog.vue?vue&type=script&lang=js"
export * from "./DateRangeDialog.vue?vue&type=script&lang=js"
import style0 from "./DateRangeDialog.vue?vue&type=style&index=0&id=87b015e0&prod&lang=scss&scoped=true"
import style1 from "./DateRangeDialog.vue?vue&type=style&index=1&id=87b015e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b015e0",
  null
  
)

export default component.exports